import React from 'react'
import useConfig from 'modules/config/state/use-config'
import Row from 'modules/ui/atoms/Layout/Row'
import AnonymousNameOption from './anonymous-name-option'
import HideAmountOption from './hide-amount-option'

const AnonymousOptionsRow = () => {
  const config = useConfig()
  const isHideNameEnabled = config.anonymous.isHideNameEnabled
  const isHideAmountEnabled = config.anonymous.isHideAmountEnabled

  if (!isHideNameEnabled && !isHideAmountEnabled) {
    return null
  }

  return (
    <Row>
      {isHideNameEnabled && <AnonymousNameOption />}
      {isHideAmountEnabled && <HideAmountOption />}
    </Row>
  )
}

export default AnonymousOptionsRow
